import { ApiResponse } from "../../model/common/apiResponse";
import { LookupInterface } from "../../Pages/CompanyAccount/model/accountForm.model";
import { getLookup } from "../../Utility/Utility";
import { axiosService, ServiceEndPoint } from "./Axios.service";



export interface LookupPayload {
  params: {
    types?: string[];
  }
}
const SERVICE_URL = ServiceEndPoint.account_service;
const supplier_payload:any = {
  columns: [
    {
      data: "supplier.id",
    },
    {
      data: "supplier.code",
    },
    {
      data: "supplier.name",
    },
    {
      data: "supplier.contact_name",
    },
    {
      data: "supplier.contact_phone",
    },
    {
      data: "supplier.client_id",
    }
  ],
  limit: -1,
};
const accounts_payload={
  columns: [
    {
      data: "account.id",
    },
    {
      data: "account.code",
    },
    {
      data: "account.name",
    },
  ],
  limit: -1,
}
const warehouse_payload = {
  columns: [
    {
      data: "warehouse.id",
    },
    {
      data: "warehouse.code",
    },
    {
      data: "warehouse.name",
    },
  ],
  limit: -1,
};
const carriers_payload = {
  columns: [
    {
      data: "carrier.id",
    },
    {
      data: "carrier.code",
    },
    {
      data: "carrier.name",
    },
  ],
  limit: -1,
};


const customer_payload = {
  "columns": [
      {
          "data": "customer.id"
      },
      {
          "data": "customer.code"
      },
      {
          "data": "customer.name"
      },
      {
          "data": "customer.address_line_1"
      },
      {
          "data": "customer.address_line_2"
      },
      {
          "data": "customer.city"
      },
      {
          "data": "customer.state_province"
      },
      {
          "data": "customer.postal_code"
      },
      {
          "data": "country.name as country"
      },
      {
          "data": "customer.contact_name"
      },
      {
          "data": "customer.contact_phone"
      }
  ],
  "limit": -1
}


const itemsCreateEditLookups = {
  payloadForItemGroup:  {
    "columns": [
        {
            "data": "item_group.id"
        },
        {
            "data": "item_group.code"
        },
        {
            "data": "item_group.name"
        }
    ],
    "limit": -1
  },
  payloadForItemsCategory: {
    "columns": [
        {
            "data": "item_category.id"
        },
        {
            "data": "item_category.code"
        },
        {
            "data": "item_category.name"
        }
    ],
    "limit": -1
  }

}
 const shipTo_payload:any ={
    "columns": [
        {
            "data": "customer_ship_to.id"
        },
        {
            "data": "customer_ship_to.code"
        },
        {
            "data": "customer_ship_to.name"
        },
        {
            "data": "customer_ship_to.address_line_1"
        },
        {
            "data": "customer_ship_to.address_line_2"
        },
        {
            "data": "customer_ship_to.city"
        },
        {
            "data": "customer_ship_to.state_province"
        },
        {
            "data": "customer_ship_to.postal_code"
        },
        {
            "data": "customer_ship_to.contact_name"
        },
        {
            "data": "customer_ship_to.contact_phone"
        },
        {
            "data": "customer_ship_to.contact_email"
        },
        {
            "data": "customer_ship_to.is_residential"
        },
        {
            "data": "customer_ship_to.country_code"
        }
    ],
    "limit": -1
  }

const payloadForItems: {
  columns: { data: string; as?: string }[];
  conditions?: any;
  limit: number;
  search: string;
  page?: number;
  perPage?: number;

} = {
  columns: [
    {
      data: "item.id",
    },
    {
      data: "item.code",
    },
    {
      data: "item.name",
    },
    {
      data: "default_purchase_uom.code",
      as: "uom_code",
    },
    {
      "data": "qty_on_hand"
    }
  ],
  limit: -1,
  search: ""
};
const client_payload :{
  columns: { data: string; as?: string }[];
  conditions?:any;
  limit?: number;
  search?: string;
  page?: number;
  perPage?: number;
} ={
  "columns": [
      {
          "data": "client.id"
      },
      {
          "data": "client.code"
      },
      {
          "data": "client.name"
      },
      {
        "data": "client.is_active"
    }
  ],
  "limit": -1
}

export enum LookupType {
  AccountType = "accounts.type",
  AccountSource = "accounts.source",
  EnviromentType = "accounts.environment_type"
}


export const lookUpService = {
  supplierLookup(client_id?:string): Promise<ApiResponse<any>> {
    console.log("client_id",client_id)
    let payload = {...supplier_payload}
    if(client_id){
      payload.conditions = [["supplier.client_id", "=", client_id]]
    }
    
    return axiosService.post(`${SERVICE_URL}suppliers/query`, payload);
  },
  warehouseLookup(): Promise<ApiResponse<any>> {
    return axiosService.post(
      `${SERVICE_URL}warehouses/query`,
      warehouse_payload
    );
  },
  carriersLookup(): Promise<ApiResponse<any>> {
    return axiosService.post(`${SERVICE_URL}carriers/query`, carriers_payload);
  },
  clientLookup(status?:boolean): Promise<ApiResponse<any>> {   
    let payload = {
        ...client_payload,
    }
    if(status){
        payload.conditions =  [["client.is_active", "=", status]]
    }
    return axiosService.post(`${SERVICE_URL}clients/query`, payload);
  },

  itemsLookup(searchTerm?: string, page?: number, perPage?: number,client_id?:string): Promise<ApiResponse<any>> {
    let payload = {
      ...payloadForItems,
      search: searchTerm || "",
    };
    if (page && perPage) {
      payload = {
        ...payload,
        page: page,
        limit: perPage,
      };
    }
    if(client_id){
      payload.conditions = [["item.client_id", "=", client_id]]
    }
    return axiosService.post(`${SERVICE_URL}items/query`, payload);
  },

 
  async accountTypeLookup(): Promise<ApiResponse<LookupInterface>> {
    return getLookup(SERVICE_URL, LookupType.AccountType);
  },

  async accountSourceLookup(): Promise<ApiResponse<LookupInterface>> {
    return getLookup(SERVICE_URL, LookupType.AccountSource);
  },
  async getEnvironmentTypes(): Promise<ApiResponse<LookupInterface>> {
    return getLookup(SERVICE_URL, LookupType.EnviromentType);
  },

  async uomSystemLookup(): Promise<ApiResponse<LookupInterface>> {
    return axiosService.get(`${SERVICE_URL}global/lookup/uom_system`);
  },


  async timezoneLookup(): Promise<ApiResponse<LookupInterface>> {
    return axiosService.get(`${SERVICE_URL}global/lookup/get_timezones`);
  },

  async countryLookup(): Promise<ApiResponse<any>> {
    return axiosService.get(`${SERVICE_URL}global/lookup/get_countries`);
  },

  getAccounts(): Promise<ApiResponse<any>> {
    return axiosService.post(`${SERVICE_URL}accounts/query`, accounts_payload);
  },
  // Items Add Edit Lookup services
  getItemCategoryLookup(): Promise<ApiResponse<any>>{
    return axiosService.post(`${SERVICE_URL}item-categories/query`, itemsCreateEditLookups.payloadForItemsCategory);
  },
  getItemGroupLookup(): Promise<ApiResponse<any>>{
    return axiosService.post(`${SERVICE_URL}item-groups/query`, itemsCreateEditLookups.payloadForItemGroup);
  },
  lookupByType(item_lookup_payload: any): Promise<ApiResponse<any>> {
    return axiosService.post(`${SERVICE_URL}lookup/get_multiple`,item_lookup_payload);
  },
  shipToLookup(customer_id?:string): Promise<ApiResponse<any>> {
    const payload = {
      ...shipTo_payload,
         conditions: [
      ["customer.id", "=", customer_id]
      ],

    }
    return axiosService.post(`${SERVICE_URL}customer-ship-tos/query`, payload);
  },
  customerLookup(): Promise<ApiResponse<any>> {
    return axiosService.post(`${SERVICE_URL}customers/query`, customer_payload);
  }
};






